import { render, staticRenderFns } from "./AddressSetting.vue?vue&type=template&id=54af120a&scoped=true&"
import script from "./AddressSetting.vue?vue&type=script&lang=js&"
export * from "./AddressSetting.vue?vue&type=script&lang=js&"
import style0 from "./AddressSetting.vue?vue&type=style&index=0&id=54af120a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af120a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54af120a')) {
      api.createRecord('54af120a', component.options)
    } else {
      api.reload('54af120a', component.options)
    }
    module.hot.accept("./AddressSetting.vue?vue&type=template&id=54af120a&scoped=true&", function () {
      api.rerender('54af120a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/AddressSetting.vue"
export default component.exports